<!-- Header -->
<div class="modal-header">

  <!-- Title -->
  <h6 class="modal-title" i18n="@@shared.components.delete_tenant_modal.title">Delete Tenant</h6>
  <!-- Title end -->

  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
    &times;
  </button>
</div>
<!-- Header end -->

<!-- Content -->
<div class="modal-body">
  <div>
    <p i18n="@@shared.components.delete_tenant_modal.description_1">We are sorry to see that you want to delete your tenant.</p>
    <p i18n="@@shared.components.delete_tenant_modal.description_2">If you have any questions or concerns regarding your Parashift tenant we are always happy to help.</p>
    <p i18n="@@shared.components.delete_tenant_modal.description_3">Please write us an e-mail to the following mail address with the following information so that we can do the deletion for you.</p>

    <p class="font-monospace bg-light p-3">
      <ng-container i18n="@@shared.components.delete_tenant_modal.label.recipient">Recipient:</ng-container> support&#64;parashift.io<br>
      <ng-container i18n="@@shared.components.delete_tenant_modal.label.subject">Subject:</ng-container> {{ subject }}<br>
      <br>
      <ng-container i18n="@@shared.components.delete_tenant_modal.label.body">Message:</ng-container><br>
      <ng-container i18n="@@shared.components.delete_tenant_modal.label.tenant_id">Tenant ID:</ng-container> {{ bsModalRef.content?.model.id }}<br>
      <ng-container i18n="@@shared.components.delete_tenant_modal.label.tenant_name">Tenant Name:</ng-container> {{ bsModalRef.content?.model.name }}
    </p>
    <a class="btn btn-sm btn-dark mt-3"
       [href]="mailto">
      <fa-icon [icon]="['fas', 'envelope']" [fixedWidth]="true"></fa-icon> <ng-container i18n="@@shared.components.delete_tenant_modal.write_email">Write Email</ng-container>
    </a>
  </div>
</div>
<!-- Content end -->

<!-- Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-xs btn-secondary" (click)="close()" i18n="@@common.close">Close</button>
</div>
<!-- Footer end -->
